import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

function Terms() {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <nav className="container">
          <Link to="/" className="back-link">← 返回首页</Link>
        </nav>
      </header>
      <div className="container">
        <h1>服务条款</h1>
        <p className="last-updated">最后更新：2024年11月</p>

        <section className="legal-section">
          <h2>1. 服务范围</h2>
          <p>杭州斯代拉科技有限公司（以下简称"本公司"）为客户提供移动应用开发及相关技术服务，包括但不限于：</p>
          <ul>
            <li>iOS/Android应用定制开发</li>
            <li>应用UI/UX设计</li>
            <li>后台系统开发</li>
            <li>应用上架指导</li>
            <li>技术支持与维护服务</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>2. 服务流程</h2>
          <ol>
            <li>客户通过电话（15000416741）、QQ（454784911）、邮件（454784911@qq.com）等方式联系本公司</li>
            <li>双方沟通需求，本公司提供初步方案和报价</li>
            <li>达成一致后签订开发合同，明确项目范围、交付时间、费用等</li>
            <li>按合同约定进行开发、测试、交付</li>
            <li>提供约定期限内的免费技术支持</li>
          </ol>
        </section>

        <section className="legal-section">
          <h2>3. 双方权利与义务</h2>

          <h3>3.1 客户权利</h3>
          <ul>
            <li>了解项目开发进度</li>
            <li>在合理范围内提出需求变更</li>
            <li>验收交付成果</li>
            <li>获得约定的售后服务</li>
            <li>获得完整的源代码和技术文档</li>
          </ul>

          <h3>3.2 客户义务</h3>
          <ul>
            <li>按合同约定按时支付款项</li>
            <li>提供必要的资料和配合（如设计素材、接口文档等）</li>
            <li>及时反馈意见和确认阶段性成果</li>
            <li>遵守相关法律法规，不得要求开发违法违规功能</li>
            <li>妥善保管账号密码等敏感信息</li>
          </ul>

          <h3>3.3 本公司权利</h3>
          <ul>
            <li>按约定收取服务费用</li>
            <li>要求客户提供必要配合</li>
            <li>拒绝违法违规需求</li>
            <li>在案例展示中使用项目截图（涉及商业机密除外，需客户同意）</li>
          </ul>

          <h3>3.4 本公司义务</h3>
          <ul>
            <li>按约定完成开发工作</li>
            <li>保护客户商业机密和数据安全</li>
            <li>提供约定的售后服务</li>
            <li>确保交付产品质量符合行业标准</li>
            <li>及时响应客户问题和需求</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. 知识产权</h2>
          <ul>
            <li>客户委托开发的应用，知识产权归客户所有</li>
            <li>项目完成后，本公司将交付完整源代码</li>
            <li>本公司保留在案例展示中使用项目截图的权利（涉及商业机密除外，需客户书面同意）</li>
            <li>双方应尊重第三方知识产权，不得侵犯他人合法权益</li>
            <li>如使用第三方开源代码或商业组件，需遵守相应许可协议</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>5. 保密条款</h2>
          <ul>
            <li>双方对合作过程中获知的商业机密负有保密义务</li>
            <li>保密信息包括但不限于：技术方案、业务数据、用户信息、财务信息等</li>
            <li>保密期限：合同终止后3年</li>
            <li>违反保密义务的一方应承担相应法律责任和经济赔偿</li>
            <li>经双方书面同意或法律法规要求的情况除外</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. 费用与支付</h2>
          <ul>
            <li>服务费用根据项目复杂度、开发周期等因素确定</li>
            <li>一般采用分期付款方式：签约时支付30-50%，开发完成支付30-40%，验收通过支付剩余款项</li>
            <li>支付方式：银行转账、微信支付、支付宝等</li>
            <li>如客户要求变更需求导致工作量增加，需另行协商费用</li>
            <li>逾期付款的，本公司有权暂停服务</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>7. 项目变更</h2>
          <ul>
            <li>项目开发过程中，如需变更需求，应及时书面通知对方</li>
            <li>重大变更需双方协商一致，可能涉及费用和工期调整</li>
            <li>轻微调整在合理范围内不额外收费</li>
            <li>频繁变更需求可能导致项目延期，责任由客户承担</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>8. 验收标准</h2>
          <ul>
            <li>功能实现符合合同约定和需求文档</li>
            <li>无重大bug，不影响正常使用</li>
            <li>性能达到约定标准</li>
            <li>提供完整的源代码和技术文档</li>
            <li>客户应在收到交付物后7个工作日内完成验收</li>
            <li>逾期未提出异议视为验收通过</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>9. 售后服务</h2>
          <ul>
            <li>基础版：提供3个月免费技术支持</li>
            <li>标准版：提供6个月免费技术支持</li>
            <li>定制版：提供12个月免费技术支持</li>
            <li>免费服务包括：bug修复、技术咨询、使用培训</li>
            <li>不包括：新功能开发、需求变更、第三方服务费用</li>
            <li>超出免费期限的技术支持按实际工作量收费</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>10. 违约责任</h2>
          <ul>
            <li>任何一方违约应承担违约责任</li>
            <li>因本公司原因导致项目延期超过约定时间30%的，客户有权要求退款</li>
            <li>因客户原因导致项目无法进行的，已支付费用不予退还</li>
            <li>泄露商业机密的，违约方应赔偿对方损失</li>
            <li>因不可抗力（自然灾害、政策变化等）导致无法履行合同的，可免除责任</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>11. 争议解决</h2>
          <ul>
            <li>双方应本着友好协商的原则解决争议</li>
            <li>协商不成的，可向消费者协会或相关部门投诉</li>
            <li>仍无法解决的，提交杭州市余杭区人民法院诉讼解决</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>12. 其他条款</h2>
          <ul>
            <li>本条款的解释权归本公司所有</li>
            <li>本公司保留随时修改本条款的权利，修改后将在网站公布</li>
            <li>继续使用服务视为接受修改后的条款</li>
            <li>如部分条款无效，不影响其他条款的效力</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>13. 联系方式</h2>
          <p>如对本服务条款有任何疑问，请联系我们：</p>
          <ul>
            <li>公司名称：杭州斯代拉科技有限公司</li>
            <li>联系电话：15000416741</li>
            <li>客服QQ：454784911</li>
            <li>电子邮箱：454784911@qq.com</li>
            <li>工作时间：周一至周五 9:00-18:00</li>
            <li>公司地址：浙江省杭州市余杭区高教镇凤仪大道966号2号楼6层603室6414室</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default Terms;
